import { FC } from 'react';
import { useMethods } from '@lhb/hook';
import { isNotEmpty } from '@lhb/func';
import V2Tabs from '@/common/components/Data/V2Tabs';
import { ReportData } from '../../types';
import { reportNavigationItems } from '../../adapters';
import styles from '../../index.module.less';

const SectionNav: FC<{ data: ReportData; activeKey: string; onChange: (key: string) => void }> = ({ data, activeKey, onChange }) => {
  const methods = useMethods({
    spotValues() {
      return data.survey.slice(0, 3).filter(item => isNotEmpty(item.value)).map(item => item.value).join(' · ') || '-';
    },
    hint(key: string, item: { hint?: string }) {
      if (item.hint) return item.hint;
      if (key === 'spot') {
        const floorHeight = data.survey.find(item => item.label === '层高')?.value;
        return isNotEmpty(floorHeight) ? '面积 · 楼层 · 层高' : '面积 · 楼层';
      }
      if (key === 'business') {
        return isNotEmpty(data.overview?.leasePeriod) ? `月租金 · ${data.overview?.leasePeriod}月租期` : '月租金 · 租期';
      }
      return ({ mall: '商场等级 · 城市排名', traffic: '日均客流 · 峰值时段', decision: '销售额预估' } as Record<string, string>)[key] || '';
    },
    items() {
      return [
        ...reportNavigationItems(data),
      ].map(item => ({ key: item.key, label: <div className={styles.navCard}>
        <span className={styles.navLabel}>{item.label}</span>
        <span className={styles.navValue}><span className={styles.navValueText}>{item.key === 'spot' ? methods.spotValues() : item.summary}</span>{item.tag && <span className={styles.navTag}>{item.tag}</span>}</span>
        <span className={styles.navHint}>{methods.hint(item.key, item)}</span>
      </div> }));
    },
  });
  return <V2Tabs activeKey={activeKey} items={methods.items()} onChange={onChange} />;
};
export default SectionNav;
